var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccordionStepActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.145 12.0007C18.145 12.5105 17.7318 12.9238 17.222 12.9238H6.77855C6.26874 12.9238 5.85547 12.5105 5.85547 12.0007C5.85547 11.4909 6.26874 11.0776 6.77855 11.0776H17.222C17.7318 11.0776 18.145 11.4909 18.145 12.0007Z",
    fill: "#2468FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccordionStepActive);
export default __webpack_public_path__ + "static/media/accordion_step_active.6b8dfbc8c06c337046f27b212cfdfc20.svg";
export { ForwardRef as ReactComponent };